const BLOCKED_REDIRECT_PREFIXES = ['/auth', '/logout'];

// Origen ficticio: si el redirect resuelto cambia de origen, apuntaba fuera del backoffice (open redirect).
const PARSE_ORIGIN = 'https://backoffice.invalid';

export function getLinkToken(hash) {
  const token = new URLSearchParams((hash || '').replace(/^#/, '')).get('token');
  return token?.trim() || null;
}

export function sanitizeRedirect(redirect) {
  if (typeof redirect !== 'string' || !redirect.startsWith('/')) return null;

  let url;
  let routedPath;
  try {
    url = new URL(redirect, PARSE_ORIGIN);
    // Tal como la verá el router: history decodifica una vez (/%6Cogout es /logout) y no distingue mayúsculas.
    routedPath = decodeURI(url.pathname).toLowerCase();
    // Y el navegador la vuelve a parsear al navegar (quita tabuladores, \ vale /): debe seguir en el origen.
    if (url.origin !== PARSE_ORIGIN || new URL(routedPath, PARSE_ORIGIN).origin !== PARSE_ORIGIN) return null;
  } catch {
    return null;
  }

  const isBlocked = BLOCKED_REDIRECT_PREFIXES.some((prefix) => routedPath === prefix || routedPath.startsWith(`${prefix}/`));

  return isBlocked ? null : `${url.pathname}${url.search}${url.hash}`;
}
